import { createFileRoute, redirect } from "@tanstack/react-router";
import { EmptyState } from "@/components/app/lists/empty-state";
import { PageHeader } from "@/components/app/shell/page-header";
import { firstSettingsPath } from "@/lib/workspace/settings-landing";

/** Settings opens on the first setting this person may change, the way Core's does. */
export const Route = createFileRoute("/_authenticated/ws/settings/")({
  beforeLoad: ({ context }) => {
    const first = context.me ? firstSettingsPath(context.me) : null;
    if (first) throw redirect({ to: first, replace: true });
  },
  component: NothingToSetUp,
});

function NothingToSetUp() {
  return (
    <div className="mx-auto w-full max-w-3xl space-y-6">
      <PageHeader title="Settings" />
      <EmptyState
        title="There is nothing here for you to set up."
        description="Ask an administrator if a setting needs to change."
      />
    </div>
  );
}
